import { platformNames } from 'shared/constants';
import { AdditionalRequestOptions } from './types';


export const defaultRequestOptions: AdditionalRequestOptions = {
  CSRF: true,
  STORE: true,
  CATALOG_TAG_FILTER: __PLATFORM__ !== platformNames.NYKAA,
};
